import { Money, parseMoney } from '@betterment/core';

import { payrollContributionRateToString } from '~/b4b/utils/formatHelpers';
import { PayrollContributionRate, PayrollContributionRateInput } from '~/graphql/schema';

import { ContributionRateEditorValue } from './types';

export function editorValueToRate(value: ContributionRateEditorValue): PayrollContributionRate {
  switch (value.type) {
    case 'PayrollContributionPercent':
      return { __typename: value.type, percent: Number(value.text) || 0 };
    case 'PayrollContributionAmount':
      return { __typename: value.type, amount: parseMoney(value.text) ?? Money(0) };
    default:
      throw TypeError('Unexpected type name on union type.');
  }
}

export function editorValueToRateInput(value: ContributionRateEditorValue): PayrollContributionRateInput {
  const rate = editorValueToRate(value);
  switch (rate.__typename) {
    case 'PayrollContributionPercent':
      return { percent: rate.percent };
    case 'PayrollContributionAmount':
      return { amount: rate.amount };
    default:
      throw TypeError('Unexpected type name on union type.');
  }
}

export function editorValueToString(value: ContributionRateEditorValue) {
  return payrollContributionRateToString(editorValueToRate(value));
}

export function createFormikFieldName(...parts: string[]) {
  return parts.join('.');
}
